import { ColumnDTO, ExportConfigDTO, exportFile, FilterDTO, GetItemsProps, useApiService } from "medere-ui-framework";

export function useOperationRoomService() {
  const { getMethod, tableMethod } = useApiService();
  const baseEndpoint = "/api/secured/surgery";

  function getSurgeryList(offset: number, pageSize: number, params: any): Promise<any[]> {
    return tableMethod<any[]>({
      basePath: baseEndpoint,
      endpoint: "/getSurgeryList",
      bodyTable: {
        offSet: offset,
        pageSize,
        filters: params.filterDTO,
        sortingFieldInfoList: params.multiSortMeta
      },
      params: {
        patient: params.patient,
        professional: params.professional,
        surgerylocation: params.surgerylocation,
        fromDate: params.fromDate,
        toDate: params.toDate
      }
    }).catch((error) => {
      console.error(error);
      return undefined as any;
    });
  }

  function getHospitalLocations({ filterValue, offSet, pageSize }: GetItemsProps) {
    return getMethod<any[]>({
      basePath: baseEndpoint,
      endpoint: "/getHospitalLocations",
      params: {
        offSet,
        pageSize,
        inputText: filterValue ?? ""
      }
    }).then((data) => {
      const uniqueLocations = Array.from(new Map(data.map(item => [item.description, item])).values());
      return uniqueLocations;
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function getExcelDocument(params: { filterDTO: FilterDTO, multiSortMeta: any, fromDate: Date, toDate: Date, surgerylocation: any, professional: any, patient: any }, columns: ColumnDTO[]) {
    const exportConfigDTO: ExportConfigDTO = {
      loadConfigDTO: {
        offset: 0,
        pageSize: 0,
        sortingFieldInfoList: params.multiSortMeta,
        filters: params.filterDTO
      },
      columns
    };
    return exportFile(`${baseEndpoint}/getExcelDocument`, exportConfigDTO, { patient: params.patient, professional: params.professional, hospitallocation: params.surgerylocation, fromDate: params.fromDate, toDate: params.toDate });
  }

  return {
    getSurgeryList,
    getHospitalLocations,
    getExcelDocument
  };
}
